/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_No_SubjectsInputs */

const cs_property_lustrace_no_subjects = /** @type {(inputs: Property_Lustrace_No_SubjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné strany s IČO nebo jménem a žádné ruční IČO. Přidejte prodávající/vlastníky nebo zadejte IČO níže.`)
};

const en_property_lustrace_no_subjects = /** @type {(inputs: Property_Lustrace_No_SubjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No parties with IČO or name, and no manual IČO. Add sellers/owners or enter an IČO below.`)
};

/**
* | output |
* | --- |
* | "No parties with IČO or name, and no manual IČO. Add sellers/owners or enter an IČO below." |
*
* @param {Property_Lustrace_No_SubjectsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_no_subjects = /** @type {((inputs?: Property_Lustrace_No_SubjectsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_No_SubjectsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_no_subjects(inputs)
	return cs_property_lustrace_no_subjects(inputs)
});